import React from 'react';
import { Navigate } from 'react-router-dom';
import { PATHS, ADMIN_PATHS } from './paths';
import SubdomainGate from './SubdomainGate';
import ModuleGate from './ModuleGate';
import UrlAccessGate from './UrlAccessGate';
import RouteError from './RouteError';
import { authLoader } from './loaders/authLoader';
import { requireSubdomain } from './loaders/subdomainLoader';
import { logoutLoader, unauthLogoutLoader } from './loaders/logoutLoader';

import { Auth } from '../middlewares/auth';
import SignedOut from '../containers/SignedOut';
import Header from '../containers/Header';
import HeaderTemplate from '../components/HeaderTemplate';
import WorkkardDetail from '../containers/WorkkardDetail';
import PrintWorkkardDetail from '../containers/WorkkardDetail/PrintWorkkardDetail';
import WorkkardListing from '../containers/WorkkardListing';
import ActivityListing from '../containers/ActivityListing';
import DiariesListing from '../containers/Diaries';
import AdminPanel from '../containers/AdminPanel';
import AddEditActivity from '../containers/CreationForms/AddEditActivity';
import AddEditWorkkard from '../containers/CreationForms/AddEditWorkkard';
import Views from '../containers/Views';
import Agreement from '../containers/Agreement'
import PrivacyPolicy from '../containers/PrivacyPolicy'

const withHeader = (text) => ({ headerText: text });


const routes = [
    {
        path: PATHS.ROOT,
        element: <Auth />,
        errorElement: <RouteError />,
    },
    {
        path: PATHS.LOGOUT,
        loader: logoutLoader,
        errorElement: <RouteError />,
    },
    {
        path: PATHS.UNAUTH_LOGOUT,
        loader: unauthLogoutLoader,
        errorElement: <RouteError />,
    },
    {
        path: PATHS.SIGNED_OUT,
        element: <SignedOut />,
        errorElement: <RouteError />,
    },
    {
        loader: authLoader,
        errorElement: <RouteError />,
        children: [
            {
                element: <Header />,
                children: [
                    {
                        element: <UrlAccessGate />,
                        children: [
                            {
                                element: <HeaderTemplate />,
                                children: [
                                    { path: PATHS.WORKKARD_DETAIL, element: <WorkkardDetail /> },
                                    { path: PATHS.ACTIVITY_DETAIL, element: <WorkkardDetail /> },
                                    { path: PATHS.PRINT_WORKKARD_DETAIL, element: <PrintWorkkardDetail /> },
                                    {
                                      path: PATHS.WORKKARD_CREATE,
                                      element: <AddEditWorkkard />,
                                      handle: withHeader('Create a new Workkard'),
                                    },
                                    {
                                      path: PATHS.WORKKARD_EDIT,
                                      element: <AddEditWorkkard isEdit={true} />,
                                      handle: withHeader('Edit Workkard'),
                                    },
                                    {
                                      path: PATHS.ACTIVITY_CREATE,
                                      element: <AddEditActivity />,
                                      handle: withHeader('Create a new activity'),
                                    },
                                    {
                                      path: PATHS.ACTIVITY_EDIT,
                                      element: <AddEditActivity isEdit={true} />,
                                      handle: withHeader('Edit Activity'),
                                    },

                                    {
                                        path: PATHS.WORKKARD_LIST_LEGACY,
                                        element: <WorkkardListing isEdit={true} />,
                                        handle: withHeader('Workkards'),
                                    },
                                    {
                                        path: PATHS.WORKKARDS,
                                        element: <WorkkardListing />,
                                        handle: withHeader('Workkards'),
                                    },
                                    {
                                        path: PATHS.POLICIES,
                                        element: <WorkkardListing />,
                                        handle: withHeader('Policies'),
                                    },
                                    {
                                        path: PATHS.ACTIVITIES,
                                        element: <ActivityListing />,
                                        handle: withHeader('Activities'),
                                    },
                                    {
                                        path: PATHS.REQUESTS,
                                        element: <ActivityListing />,
                                        handle: withHeader('Requests'),
                                    },
                                    {
                                        path: PATHS.TDO,
                                        element: <ModuleGate module="diaries"><DiariesListing /></ModuleGate>,
                                        handle: withHeader('Diaries'),
                                    },
                                    {
                                        path: PATHS.DIARIES,
                                        element: <ModuleGate module="diaries"><DiariesListing /></ModuleGate>,
                                        handle: withHeader('Diaries'),
                                    },
                                    {
                                        path: PATHS.VIEWS,
                                        element: <Navigate to={`${PATHS.VIEWS}/new`} replace />,
                                    },
                                    {
                                        path: `${PATHS.VIEWS}/*`,
                                        element: <Views />,
                                        handle: withHeader(''),
                                    },
                                    {
                                        path: `${PATHS.AGREEMENT}/*`,
                                        element: <Agreement />,
                                        handle: withHeader(''),
                                    },
                                    {
                                        path: `${PATHS.Privacy_Policy}/*`,
                                        element: <PrivacyPolicy />,
                                        handle: withHeader(''),
                                    },
                                    // {
                                    //     path: PATHS.INBOX,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Inbox'),
                                    // },
                                    // {
                                    //     path: PATHS.BULK_INBOX,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Bulk Inbox'),
                                    // },
                                    // {
                                    //     path: PATHS.DESKS,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Desks'),
                                    // },
                                    // {
                                    //     path: PATHS.REVIEW_CENTER,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Review Center'),
                                    // },
                                    // {
                                    //     path: PATHS.APPROVALS,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Pending Approvals'),
                                    // },
                                    // {
                                    //     path: PATHS.LETTERS,
                                    //     element: <DiariesListing />,
                                    //     handle: withHeader('Letters'),
                                    // },
                                ],
                            },
                            {
                                loader: requireSubdomain('admin'),
                                element: <SubdomainGate requiredSubdomain="admin" />,
                                children: [
                                    ...ADMIN_PATHS.map((path) => ({
                                        path,
                                        element: <AdminPanel />,
                                    })),
                                    {
                                        path: PATHS.MANAGE_WORKLOAD,
                                        element: <AdminPanel />,
                                        handle: withHeader('ManageWorkload'),
                                    },
                                    {
                                        path: PATHS.USER_ADD,
                                        element: <AdminPanel />,
                                    },
                                    {
                                        path: PATHS.USER_EDIT,
                                        element: <AdminPanel />,
                                    },
                                    {
                                        path: PATHS.USER_PROFILE,
                                        element: <AdminPanel />,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default routes;
